<template>
  <div class="about-us">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ title }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <van-cell-group>
        <van-field
          v-model="len"
          :label="$t('Home.l5w8fq')"
          @change="onchange"
          :placeholder="$t('请输入长度(CM)')"
          :border="true"
        />
        <van-field
          v-model="wid"
          :label="$t('Home.v5wnxc')"
          type="number"
          @change="onchange"
          :placeholder="$t('请输入宽度(CM)')"
          :border="true"
        />
        <van-field
          v-model="hei"
          :label="$t('Home.uksvhr')"
          type="number"
          @change="onchange"
          :placeholder="$t('请输入高度(CM)')"
          :border="true"
        />
        <van-field
          v-model="wei"
          :label="$t('Home.370000')"
          type="digit"
          @change="onchange"
          :placeholder="$t('请输入重量(KG)')"
          :border="true"
        />
        <van-field v-model="vol" :label="$t('Home.630000')" :border="true">
          <template #button>
            <van-button
              size="small"
              type="primary"
              id="copy"
              :data-clipboard-text="vol"
              @click="copy"
              >{{ $t('复制') }}</van-button
            >
          </template>
        </van-field>
        <van-field v-model="des" :label="$t('Home.密度')" :border="true">
          <template #button>
            <van-button
              size="small"
              type="primary"
              id="copy"
              :data-clipboard-text="des"
              @click="copy"
              >{{ $t('复制') }}</van-button
            >
          </template></van-field
        >
      </van-cell-group>
    </main>
  </div>
</template>
<script>
import { $t } from '@/plugins/i18n';
import Clipboard from 'clipboard';

export default {
  data() {
    return {
      title: $t('体积计算'),
      len: '',
      wid: '',
      hei: '',
      wei: '',
      vol: '',
      des: '',
    };
  },
  mounted() {},
  methods: {
    onchange() {
      this.len = this.len || 0;
      this.wid = this.wid || 0;
      this.hei = this.hei || 0;
      this.vol = (this.len * this.wid * this.hei) / 1000000;
      this.vol = this.vol.toFixed(4);
      if (this.wei > 0) {
        this.des = (this.wei / this.vol).toFixed(4);
      }
    },
    copy() {
      let _this = this;
      let clipborad = new Clipboard('#copy');
      //复制成功
      clipborad.on('success', function() {
        _this.$toast.success($t('复制成功！'));
        clipborad.destory();
      });
      //复制失败
      clipborad.on('error', function() {
        _this.$toast.fail($t('复制失败！'));
        clipborad.destory();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';

.banner {
  height: rem(240px);
  margin-bottom: rem(40px);
  background-color: $theme-color;
  background-size: cover;
}
.page-body {
  padding: rem(40px);
  background: #fff;
}
h1 {
  font-size: 16px;
}
h2 {
  font-size: 12px;
  color: #b8b8b8;
}
p {
  line-height: 1.5;
}
</style>
